export const isSurveyExpired = (endDate, now = new Date()) => {
  if (!endDate) return false;

  const match = String(endDate).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return false;

  const endOfDay = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 23, 59, 59, 999);
  return !Number.isNaN(endOfDay.getTime()) && now > endOfDay;
};

export const formatSurveyPostedDate = (dateString, now = Date.now()) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";

  const minutes = Math.max(0, Math.floor((now - date.getTime()) / 60000));
  if (minutes < 60) return `${Math.max(1, minutes)} Min Ago`;
  if (minutes < 1440) {
    const hours = Math.floor(minutes / 60);
    return `${hours} ${hours === 1 ? "Hr" : "Hrs"} Ago`;
  }
  if (minutes < 10080) {
    const days = Math.floor(minutes / 1440);
    return `${days} ${days === 1 ? "Day" : "Days"} Ago`;
  }

  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};
